import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EErrorPageCodeKey = {
	notFound: 'notFound',
	noAccess: 'noAccess',
	noRoles: 'noRoles',
} as const;

export type TErrorPageCodeKey = TValueOfStringRecord<typeof EErrorPageCodeKey>

export const errorText = {
	[EErrorPageCodeKey.notFound]: {
		title: `That page doesn't exist!`,
		text: 'Sorry, the page you were looking for could not be found.',
		btnText: 'Go to home page',
	},
	[EErrorPageCodeKey.noAccess]: {
		title: 'Restricted access...',
		text: `The page you're trying to access has restricted access.
		Please refer to your Organisation Administrator`,
		btnText: 'Go back',
	},
	[EErrorPageCodeKey.noRoles]: {
		title: `You don't have any assigned role!`,
		text: 'Please contact your organisation administrator',
		btnText: null,
	},
};
